// «Modifica» di un provider collegato (tela, artboard 50): il nome dell'account, per distinguere
// più account dello stesso tipo, e un token nuovo per chi si collega con un token (Claude Code, la
// chiave di Antigravity). Il token nuovo PopTown lo prova prima di sostituire quello di oggi.
import { useState } from 'react';
import { api, ApiError } from '../../lib/api';
import type { ConnectedProvider } from '../../lib/api';
import { Banner } from '../../components/Banner';
import { Button } from '../../components/Button';
import { Field, TextField } from '../../components/Field';
import { Modal } from '../../components/Modal';

const KIND_LABEL: Record<string, string> = {
  local: 'Locale (SurgeAI)',
  'claude-code': 'Claude Code · abbonamento Claude',
  codex: 'Codex · abbonamento ChatGPT',
  antigravity: 'Antigravity (Gemini)',
};

export function EditProvider({
  provider,
  onClose,
}: {
  provider: ConnectedProvider;
  onClose: (changed: boolean) => void;
}) {
  const [name, setName] = useState(provider.name);
  const [token, setToken] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const takesToken = provider.kind === 'claude-code' || provider.kind === 'antigravity';

  const save = async () => {
    setBusy(true);
    setError(null);
    try {
      await api.updateProvider(provider.id, { name, token: token.trim() || null });
      onClose(true);
    } catch (e) {
      setError(e instanceof ApiError && e.detail ? e.detail : 'Modifica non riuscita.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal
      title="Modifica account"
      width={480}
      onClose={() => onClose(false)}
      footer={
        <>
          <Button variant="secondary" onClick={() => onClose(false)}>
            Annulla
          </Button>
          <Button
            variant="primary"
            loading={busy}
            disabled={!name.trim()}
            onClick={() => void save()}
          >
            Salva
          </Button>
        </>
      }
    >
      <div style={{ display: 'grid', gap: 14 }}>
        <div className="t-small dim">{KIND_LABEL[provider.kind] ?? provider.kind}</div>
        <Field label="Nome" hint="Come lo vedi nei provider e nella scelta del modello.">
          <TextField value={name} onChange={setName} autoFocus />
        </Field>
        {takesToken && (
          <Field
            label={provider.kind === 'claude-code' ? 'Nuovo token' : 'Nuova chiave API'}
            hint={
              provider.kind === 'claude-code'
                ? 'Da «claude setup-token». Lascia vuoto per tenere quello di oggi: PopTown prova il nuovo prima di sostituirlo.'
                : 'Solo se l’account usa una chiave API. Lascia vuoto per tenere quella di oggi.'
            }
          >
            <TextField
              type="password"
              value={token}
              onChange={setToken}
              placeholder="Lascia vuoto per tenere quello di oggi"
              autoComplete="off"
              mono
            />
          </Field>
        )}
        {error && <Banner kind="danger">{error}</Banner>}
      </div>
    </Modal>
  );
}
